import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getLastVehiclesRequest } from 'store/modules/comuns/lastVehicles/reducer'
import { FormCombobox } from 'components/CoForm/components'
import formatter from '@/services/formatter'

export function ComboboxLastVehicles({ ...props }) {
  const dispatch = useDispatch()
  const vehicles = useSelector((state) => state.comuns.lastVehicles.vehicles)
  const loading = useSelector((state) => state.comuns.lastVehicles.loading)

  const options = useMemo(() => {
    return vehicles.map((vehicle) => ({
      value: vehicle.pla_vei,
      label: vehicle.pla_vei,
      truckTypeId: 0,
      capacity: vehicle.pes_max,
      secondary: formatter(Number(vehicle.pes_max)).toDecimal(),
    }))
  }, [vehicles])

  useEffect(() => {
    dispatch(getLastVehiclesRequest())
  }, [dispatch])

  return (
    <FormCombobox
      freeSolo
      autoSelect={false}
      clearOnEscape={false}
      selectOnFocus={false}
      clearOnBlur={false}
      className="FormRow-plate"
      id="combo-last-vehicles"
      options={options}
      loading={loading}
      {...props}
    />
  )
}

export default ComboboxLastVehicles
